import $ from 'jquery'
import Screen from './screen'

const TabletViewport = () => {
  const screen = new Screen()
  if (screen.isTablet) {
    $('html meta[name="viewport"]').attr('content', 'width=896')
  }
}

export default TabletViewport
